import { HttpStatusCode } from 'axios';
export { HttpStatusCode };
export enum HttpMethod {
  Get = 'GET',
  Put = 'PUT',
  Post = 'POST',
  Patch = 'PATCH',
  Delete = 'DELETE',
}
export const ACCOUNT_ID_IDENTIFIER = 'account:id';
export const JSON_HEADER = {
  'Content-type': 'application/json'
};
export const cancelMessage = (url: string) => `Concurrent call to ${url}. Cancelling previous call...`;

/**
 * CSRF Protection constants
 * Must match backend values in api-dashboard/source/src/middleware/CsrfProtection.ts
 */
export const CSRF_COOKIE_NAME = 'csrf-token';
export const CSRF_HEADER_NAME = 'x-csrf-token';

/**
 * Request correlation header for distributed tracing
 * Must match backend value in @commutifi/constants/Headers.ts
 * Frontend generates this ID, backend uses it for logs correlation
 */
export const REQUEST_ID_HEADER = 'x-commutifi-request-id';